module.exports = __webpack_public_path__ + "static/img/VacuumMainImg-P.0de18d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/VacuumMainImg-P.png
// module id = oVFs
// module chunks = 1